import React from 'react';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { InputAdornment, TextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material/TextField';
import { adminCombineSx, adminSearchFieldSx } from '../../styles/adminComponentStyles';

type AdminSearchFieldProps = Omit<TextFieldProps, 'size' | 'variant'>;

const AdminSearchField = React.forwardRef<HTMLDivElement, AdminSearchFieldProps>(
  ({ InputProps, placeholder = 'Search', sx, ...props }, ref) => (
    <TextField
      ref={ref}
      fullWidth
      placeholder={placeholder}
      size="small"
      variant="outlined"
      sx={adminCombineSx(adminSearchFieldSx, sx)}
      InputProps={{
        ...InputProps,
        startAdornment: InputProps?.startAdornment ?? (
          <InputAdornment position="start">
            <SearchRoundedIcon />
          </InputAdornment>
        ),
      }}
      {...props}
    />
  ),
);

AdminSearchField.displayName = 'AdminSearchField';

export default React.memo(AdminSearchField);
